import _ from 'lodash';
import { actions, actionTypes } from './modules';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { applicationIdsSelector, guildIdSelector } from './selectors';
import { apiServiceAsync } from '../services/apiService';
import { RecruitmentEntityType } from '../../../../../shared/types/recruitmentTypes';

const {
  loadGuildRecruitmentProfileSuccess,
  loadGuildRecruitmentProfileFail,

  requestApplicationSuccess,
  requestApplicationFail
} = actions;

function* fetchGuildRecruitmentProfilesSaga(): any {
  const guildId = yield select(guildIdSelector);
  try {
    const { profiles } = yield call(apiServiceAsync.getTargetRecruitmentProfiles, RecruitmentEntityType.Guild, guildId);
    yield put(loadGuildRecruitmentProfileSuccess(profiles));
  } catch (e) {
    yield put(loadGuildRecruitmentProfileFail());
  }
}

function* requestApplicationSaga(action: any): any {
  const applicationReq = yield select(applicationIdsSelector);
  try {
    const { recruitmentApplication } = yield call(apiServiceAsync.requestApplication, applicationReq);
    yield put(requestApplicationSuccess(recruitmentApplication.thread_id));
  } catch (e) {
    yield put(requestApplicationFail(e?.message));
  }
}

function* watchLoadGuildRecruitmentPage(): any {
  yield takeLatest(actionTypes.LOAD_GUILD_RECRUITMENT_PROFILE, fetchGuildRecruitmentProfilesSaga);
}
function* watchRequestApplication(): any {
  yield takeLatest(actionTypes.REQUEST_APPLICATION, requestApplicationSaga);
}

export default [watchLoadGuildRecruitmentPage(), watchRequestApplication()];
